import { bg_util_debounce } from "@/modules/util";

export const ScrollEventMixin = {
  name: "ScrollEventMixin",
  data() {
    return {
      scroll_event_scrollHandler: null,
      scroll_event_homeImage: "/images/home_full_name.svg",
    };
  },
  created() {
    this.scroll_event_scrollHandler = bg_util_debounce(10, () => {
      const height = window.scrollY;
      if (height === 0)
        this.scroll_event_homeImage = "/images/home_full_name.svg";
      else this.scroll_event_homeImage = "/images/home_alias.svg";
    });
    window.addEventListener("scroll", this.scroll_event_scrollHandler);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.scroll_event_scrollHandler);
  },
};
